module.exports = [{
      plugin: require('/Users/mattmadeiro/Work/space-city-cups/space-city-cups/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
